// import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// import { ModuleWithProviders, NgModule, Optional, SkipSelf, inject, provideAppInitializer } from '@angular/core';
import { APP_INITIALIZER, ModuleWithProviders, NgModule, Optional, SkipSelf, inject } from '@angular/core';
import { AuthConfig, OAuthModule, OAuthModuleConfig, OAuthStorage } from 'angular-oauth2-oidc';
import { authConfig } from './auth-config';
import { AuthGuardWithForcedLogin } from './auth-guard-with-forced-login.service';
import { AuthGuard } from './auth-guard.service';
import { authModuleConfig } from './auth-module-config';
import { AuthService } from './auth.service';
import { AuthGuardAdminRole } from './auth-admin-guard.service';

// We need a factory since localStorage is not available at AOT build time
export function storageFactory(): OAuthStorage {
	return localStorage;
}

export function authAppInitializerFactory(authService: AuthService): () => Promise<void> {
	return () => authService.runInitialLoginSequence();
}

@NgModule({
	imports: [
		OAuthModule.forRoot()
	],
	providers: [
		AuthService,
		AuthGuard,
		AuthGuardWithForcedLogin,
		AuthGuardAdminRole
		// provideHttpClient(withInterceptorsFromDi()),
	]
})
export class AuthCoreModule {
	static forRoot(): ModuleWithProviders<AuthCoreModule> {
		return {
			ngModule: AuthCoreModule,
			providers: [
				// provideAppInitializer(() => {
				// 	const initializerFn = (authAppInitializerFactory)(inject(AuthService));
				// 	return initializerFn();
				// }),
				{
					provide: APP_INITIALIZER,
					useFactory: authAppInitializerFactory,
					deps: [AuthService],
					multi: true
				},
				{ provide: AuthConfig, useValue: authConfig },
				{ provide: OAuthModuleConfig, useValue: authModuleConfig },
				{ provide: OAuthStorage, useFactory: storageFactory },
			]
		};
	}

	constructor(@Optional() @SkipSelf() parentModule: AuthCoreModule) {
		if (parentModule) {
			throw new Error('CoreModule is already loaded. Import it in the AppModule only');
		}
	}
}
